import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CustomerDetailsComponent } from '@app/pages/authenticated/components/customer-details/customer-details.component';
import { PPUPaginatedSuccessResponse, PPUSuccessResponse } from '../models/response.model';
import { environment } from 'src/environments/environment';
import { PPUCustomerDetailModel, PPUCustomerSubscriptionHistory } from '../models/customer.model';
import { CustomerSearchModel } from '../models/receive-package.model';

@Injectable({ providedIn: 'root' })
export class CustomerService {
  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
  ) {}

  public searchCustomer(searchText: string): Observable<Array<CustomerSearchModel>> {
    return this.http
      .get<
        PPUSuccessResponse<CustomerSearchModel>
      >(`${environment.API_ROOT}Agent/api/v1/Customer/AzureSearch?searchText=${searchText}`)
      .pipe(
        map((res: any) => res.results),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }

  public getCustomerById(customerId: number): Observable<any> {
    let queryParams = new HttpParams().set('Id', customerId);

    return this.http
      .get<PPUSuccessResponse<PPUCustomerDetailModel>>(`${environment.API_ROOT}Agent/api/v1/Customer/GetById`, {
        params: queryParams,
      })
      .pipe(
        map((res: any) => {
          if (res.result) {
            const subscriptionStatus = res.result.subscriptionStatus;
            if (subscriptionStatus)
              res.result.subscriptionStatus = subscriptionStatus.charAt(0).toUpperCase() + subscriptionStatus.slice(1);
            res.result.cityProvinceCountry = `${res.result.city}, ${res.result.provinceCode}, ${res.result.countryName}`;
          }
          return res.result;
        }),
        catchError((error: any): any => throwError(() => error)),
      );
  }

  public getPaymentHistoryByCustomer(customerId: number): Observable<any> {
    let queryParams = new HttpParams().set('CustomerId', customerId);

    return this.http
      .get<PPUPaginatedSuccessResponse<PPUCustomerSubscriptionHistory>>(
        `${environment.API_ROOT}Agent/api/v1/Customer/GetSubscriptionsByCustomer`,
        {
          params: queryParams,
        },
      )
      .pipe(
        map((res: any) => res.results),
        catchError((error: any): any => throwError(() => error)),
      );
  }

  public showCustomerDetails(customerId: number): void {
    this.dialog.open(CustomerDetailsComponent, {
      data: customerId,
      panelClass: 'customer-details-dialog',
    });
  }
}
